import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

// alert
import alert from '@drivesally/sally-ui/lib/libs/alert';

// Input Types
import {
  DATE,
  DATETIME,
  EXPLICIT_SWITCH,
  NUMBER,
  SELECT,
  SWITCH,
  TEXT,
  TEXTAREA,
  TOGGLE,
} from '@drivesally/sally-fn/lib/inputTypes';

// Components
import {
  Input,
  Select,
  DatePickerInput,
  ExplicitCheckBox,
  DateTimePickerInput,
  CheckBox,
  Switch,
  Textarea,
  Range,
} from '@drivesally/sally-ui';
import {AttributeText} from '../../atoms/AttributeText';

import Bold from './components/Bold';

// Lib
import prepareSelectOptions from './prepareSelectOptions';
import isBoolean from '../../../../libs/isBoolean';

class AttributeInput extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    value: PropTypes.object,
    errors: PropTypes.array,
    possibleOptions: PropTypes.array,
    options: PropTypes.array,
    removeOptions: PropTypes.array,
    required: PropTypes.array,
    auth: PropTypes.array,

    initialized: PropTypes.bool,
    token: PropTypes.string,
    username: PropTypes.string,
    roles: PropTypes.object,
    computedValues: PropTypes.object,

    range: PropTypes.bool,
  };

  static defaultProps = {
    disabled: false,
    errors: [],
    possibleOptions: [],
    options: [],
    removeOptions: [],
    required: [],
    children: null,
    auth: [],
    computedValues: {},
    range: false,
  };

  static INPUTS = {
    [DATE]: DatePickerInput,
    [DATETIME]: DateTimePickerInput,
    [EXPLICIT_SWITCH]: ExplicitCheckBox,
    [NUMBER]: Input,
    [SELECT]: Select,
    [SWITCH]: CheckBox,
    [TEXT]: Input,
    [TEXTAREA]: Textarea,
    [TOGGLE]: Switch,
  };

  onDateError = (error) => alert.warning(error);

  isAuthorized = () => {
    const {initialized, token, value, auth} = this.props;
    return !auth.includes(value.attribute) || (initialized && !!token);
  };

  component = () => {
    const {value, range} = this.props;
    return value.type === NUMBER && range
      ? Range
      : this.constructor.INPUTS[this.props.value.type];
  };

  onChange = (newValue) => {
    const {onChange, disabled, value, errors, computedValues} = this.props;
    if (disabled) return;
    const attr = value.reinit(newValue, value, computedValues);
    onChange(
      attr,
      attr.attribute,
      errors.filter((e) => e !== attr.attribute)
    );
  };

  value = () => {
    if (this.props.value.type === SELECT) {
      const options = this.props.value.additional.options
        ? prepareSelectOptions(this.props.value.additional.options)
        : prepareSelectOptions([...this.props.options]);
      const possibleOptions = prepareSelectOptions(this.props.possibleOptions);
      const finalOptions = possibleOptions
        .reduce(
          (combined, opt) => {
            if (!combined.find((o) => o.value === opt.value))
              return [...combined, opt];
            return [...combined];
          },
          [...options]
        )
        .filter((opt) => !this.props.removeOptions.includes(opt.value));
      return {
        value: this.props.value.input.format() || '',
        options: finalOptions,
      };
    }
    const additional = !!this.props.value.additional
      ? {...this.props.value.additional}
      : {};
    return [DATE, DATETIME].includes(this.props.value.type)
      ? {
          value: this.props.value.value(),
          dateFormat: (...args) =>
            this.props.value.reinit(...args).input.format(),
          ...additional,
        }
      : {
          value: isBoolean(this.props.value.input.format())
            ? this.props.value.input.format()
            : this.props.value.input.format() || '',
          ...additional,
        };
  };

  content = () => {
    const {required, children, value} = this.props;
    if (!children) return null;
    if (!required.includes(value.attribute)) return children;
    return <Bold>{children} *</Bold>;
  };

  additionalInputAttributes = () => {
    if (this.props.value.type === NUMBER) return {type: 'tel'};
    return {};
  };

  input = () => {
    const {
      onChange,
      disabled,
      value,
      errors,
      required,
      children,
      timeZone,
      ...props
    } = this.props;
    const Component = this.component();
    if ([DATE, DATETIME].includes(value.type)) {
      props.timeZone = timeZone;
      props.onError = this.onDateError;
    }
    return (
      <Component
        {...props}
        disabled={disabled}
        onChange={this.onChange}
        error={errors.includes(value.attribute)}
        {...this.additionalInputAttributes()}
        {...this.value()}
      >
        {this.content()}
      </Component>
    );
  };

  text = () => {
    const {
      initialized,
      token,
      username,
      roles,
      onChange,
      disabled,
      value,
      errors,
      possibleOptions,
      options,
      removeOptions,
      required,
      ...props
    } = this.props;
    return <AttributeText attribute={value} {...props} />;
  };

  render() {
    return this.isAuthorized() ? this.input() : this.text();
  }
}

export default connect((state) => ({...state.authorization}))(AttributeInput);
